import React from 'react';
import { Box, Grid, Container } from '@mui/material';
import { useFormStyles } from './completeRegistrationStyles';
import loginLogo from '../../assets/svg/new-logo-with-title-white.svg';

const RegistrationWrapper = ({ children }) => {
  const authStyles = useFormStyles();
  return (
    <Box sx={authStyles.pageBackground}>
      <Container maxWidth="md">
        <Grid container spacing={2} sx={authStyles.pageContainer} data-testid="welcome-index-page">
          <Grid item xs sx={authStyles.logoWrapper}>
            <Box component="img" src={loginLogo} alt="logo" sx={[authStyles.logo]} />
          </Grid>
          <Grid item xs sx={authStyles.loginFormWrapper}>
            {children}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default RegistrationWrapper;
